import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import CloseIcon16 from "../../../../assets/svg/icons/common/CloseIcon16";
import Select from "react-select";
import style from "./AssignProcessor.module.scss";
import {
  ListOfPdfs,
  getActiveBanks,
  overrideBankDetails,
  getPreappById,
} from "../../../../../api";
// import { useApplicationContext } from "../../ApplicationContext";
import toast from "react-hot-toast";
import useApplicationStore from "../../../../stores/application";

function AssignProcessor({ open, onClose, app = null }) {
  // const activeApp = useApplicationStore((state) => state.activeApp);
  let activeApp = app || useApplicationStore((state) => state.activeApp);
  const [activeBanks, setActiveBanks] = useState([]);
  const [selectedTypeOfBanks, setSelectedTypeOfBanks] = useState([]);
  const [activeTypeOfBank, setActiveTypeOfBank] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState([]);
  const [bank_file_mapping, setBank_file_mapping] = useState([]);
  const [active_addendum_list, setActive_addendum_list] = useState([]);

  useEffect(() => {
    getActiveBanks().then((res) => {
      if (res.data) {
        const options = res.data.length
          ? res.data.map((i) => ({ value: i.name, label: i.name }))
          : [];
        
        const uniqueOptions = options.filter((option, index, self) =>
          index === self.findIndex((t) => t.value === option.value)
        );
        
        setActiveBanks([...uniqueOptions]);
      }
    });
    ListOfPdfs().then((res) => {
      if (res.data.addendums_names) {
        let tempAddendumsArray = [];
        res.data.addendums_names.map((file_name, key) => {
          tempAddendumsArray.push({
            value: file_name,
            label: file_name,
          });
        });
        setBank_file_mapping(res.data.bank_file_mapping);
      }
    });
    getPreappById({ id: activeApp.id })
      .then((response) => {
        if (response.status) {
          const banks = response.data.override_bank || [];
          const uniqueBanks = banks.filter((option, index, self) =>
            index === self.findIndex((t) => t.value === option.value)
          );
          
          setSelectedTypeOfBanks(uniqueBanks);
          setActiveTypeOfBank(uniqueBanks?.[0] || null);
          setSelectedPdf(response.data.override_addendums || []);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  const onChangeTypeofBanks = (values, context) => {
    const uniqueValues = values.filter((option, index, self) =>
      index === self.findIndex((t) => t.value === option.value)
    );
    
    setSelectedTypeOfBanks(uniqueValues);
    const latest_bank = uniqueValues[uniqueValues?.length - 1] || null;
    if (context.action === "remove-value") {
      onRemoveBank(context.removedValue);
    }
    setActiveTypeOfBank(latest_bank || null);
  };

  const onSelecttypeOfBank = (typeOfBank) => {
    setActiveTypeOfBank(typeOfBank);
  };
  const onChangePdf = (e, itemName) => {
    setSelectedPdf(
      (prevSelectedPdf) =>
        Array.isArray(prevSelectedPdf)
          ? prevSelectedPdf.includes(itemName)
            ? prevSelectedPdf.filter((name) => name !== itemName) // Remove if exists
            : [...prevSelectedPdf, itemName] // Add if not present
          : [itemName], // Fallback to an array if state is unexpectedly not an array
    );
  };
  const onSubmit = () => {
    const toastId = toast.loading("Assigning bank...");
    const data = {
      app_id: activeApp.id,
      bank: selectedTypeOfBanks.length ? selectedTypeOfBanks : [],
      addendum: selectedPdf,
    };
    overrideBankDetails(data).then((res) => {
      if (res.status) {
        toast.success("Bank assigned successfully!", { id: toastId });
      } else {
        toast.error("Something went wrong!", { id: toastId });
      }
      onClose();
    })
      .catch(error => {
        toast.error("Something went wrong!", { id: toastId });
      });
  };

  useEffect(() => {
    if (activeTypeOfBank !== null && bank_file_mapping.length !== 0) {
      let bank = activeTypeOfBank.value;
      let active_addendums = bank_file_mapping[bank];
      if (
        active_addendums !== undefined &&
        active_addendums?.addendums !== undefined
      ) {
        setActive_addendum_list(active_addendums.addendums);
      } else {
        setActive_addendum_list([]);
      }
    } else {
      setActive_addendum_list([]);
    }
  }, [activeTypeOfBank]);

  const onRemoveBank = (removedVal) => {
    let bank = removedVal.value;
    let removed_bank_addendums = bank_file_mapping[bank]?.addendums;
    if (removed_bank_addendums !== undefined) {
      let new_pdfs_array = [];
      selectedPdf.forEach((pdf) => {
        if (!removed_bank_addendums.includes(pdf)) {
          new_pdfs_array.push(pdf);
        }
      });
      setSelectedPdf(new_pdfs_array);
    }
  };

  return (
    <ReactModal isOpen={open} className={style.react_modal}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <CloseIcon16 />
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Assign Processor Bank</h6>

        <div className={style.form_group}>
          <label htmlFor="email">Bank</label>
          <Select
            value={selectedTypeOfBanks}
            isMulti
            name="colors"
            options={activeBanks}
            onChange={onChangeTypeofBanks}
            className="basic-multi-select"
            classNamePrefix="select"
            maxMenuHeight={100}
            menuPlacement="bottom"
          />
        </div>

        <div className={style.active_item_section}>
          {selectedTypeOfBanks.length ? (
            selectedTypeOfBanks.map((item, index) => (
              <span
                key={item.value + "banks" + index}
                className={
                  activeTypeOfBank?.value === item.value ? style.active : ""
                }
                onClick={() => onSelecttypeOfBank(item)}
              >
                {item.label}
              </span>
            ))
          ) : (
            <></>
          )}
        </div>

        <div
          className={style.addendum_listing}
          style={{ maxHeight: "250px", overflowY: "auto" }}
        >
          {active_addendum_list.map((addendum, index) => {
            const isChecked = selectedPdf.includes(addendum);
            return (
              <div className={style.listing} key={addendum + "pdf" + index}>
                <label>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => onChangePdf(e, addendum)}
                  />
                  {addendum}
                </label>
              </div>
            );
          })}
        </div>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon bgColor={"#4C70EF"} textColor="#FFF" onClick={onSubmit}>
            Send
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default AssignProcessor;
